import { render, staticRenderFns } from "./widget-best-selling-ies.vue?vue&type=template&id=0bd884e8&scoped=true"
import script from "./widget-best-selling-ies.vue?vue&type=script&lang=js"
export * from "./widget-best-selling-ies.vue?vue&type=script&lang=js"
import style0 from "./widget-best-selling-ies.vue?vue&type=style&index=0&id=0bd884e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd884e8",
  null
  
)

export default component.exports